import { LocalizedStrings, CustomMenu } from '../models/types'

class MenuItem {
  indice = 0
  icon: any
  label: string | LocalizedStrings = ''
  name: string
  clickHandler: (() => void) | undefined = undefined
  customDisplay: string | undefined = undefined
  closeParametersOnClickInMobileMode: boolean | undefined = false

  constructor(
    indice,
    label,
    clickHandler?,
    customDisplay?,
    closeParametersOnClickInMobileMode?,
    name?
  ) {
    this.indice = indice
    this.label = label
    this.clickHandler = clickHandler
    this.customDisplay = customDisplay
    this.closeParametersOnClickInMobileMode = closeParametersOnClickInMobileMode
    this.name = name
  }

  public getAsCustomMenu(): CustomMenu {
    return {
      indice: this.indice,
      icon: this.icon,
      label: this.label,
      clickHandler: (): void => this.clickHandler && this.clickHandler(),
      customDisplay: this.customDisplay,
      closeParametersOnClickInMobileMode:
        !!this.closeParametersOnClickInMobileMode,
      name: this.name
    }
  }
}

export default MenuItem
